
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    state = 0,
    pi = 1,
    ps = 20,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.getMyTablesPage, {
        state,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
